import { render, staticRenderFns } from "./ShiftManagementDetail.vue?vue&type=template&id=10be88de"
import script from "./ShiftManagementDetail.vue?vue&type=script&lang=ts"
export * from "./ShiftManagementDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports